import React from "react";
import { connect } from "react-redux";

import * as actions from "../actions/actions";

class FortMemberHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let creator = this.props.creator;
        if (creator) {
            let creatorUploadLink = this.renderCreatorUploadLink(creator),
                suspendedFlag = this.renderSuspendedFlag(creator);
            return (
                <section
                    id="admin-user-info"
                    style={{ background: "#000000", color: "#ffffff" }}
                >
                    <style>{`
                        .ui_star.featured:before {
                            position: absolute;
                            top: 85px;
                            left: 85px;
                            background: #FFBF43;
                            border-radius: 50%;
                            padding: 5px;
                        }
                    `}</style>
                    <div className="container">
                        <div
                            className="twelve columns"
                            style={{ textAlign: "center" }}
                        >
                            <div
                                className={`${
                                    creator.featured ? "ui_star featured" : ""
                                }
                        `}
                                style={{
                                    width: "120px",
                                    position: "relative",
                                    margin: "0 auto 24px"
                                }}
                            >
                                <img
                                    src={creator.avatar}
                                    alt={creator.username}
                                    width="120"
                                    height="120"
                                />
                            </div>
                            <h3>
                                {creator.full_name}
                                {suspendedFlag}
                            </h3>
                            <p>
                                <a
                                    href={`/${creator.username}/`}
                                    className="user-link"
                                >
                                    {creator.username}
                                </a>
                            </p>
                            <p
                                style={{
                                    maxWidth: "450px",
                                    margin: "auto"
                                }}
                            >
                                {creator.description}
                            </p>
                            <ul
                                style={{
                                    textAlign: "left",
                                    position: "absolute",
                                    right: "0",
                                    top: "0",
                                    fontSize: "18px"
                                }}
                            >
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={`/fort/members/${creator.id}/`}
                                        title="View member details"
                                        target="_blank"
                                    >
                                        <span>Fort Member Page</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={`/${
                                            creator.username
                                        }/settings/invoices/`}
                                        title="View user's invoices"
                                        target="_blank"
                                    >
                                        <span>Invoices</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={`/${
                                            creator.username
                                        }/settings/icon-history/`}
                                        title="View user's icon history"
                                        target="_blank"
                                    >
                                        <span>Icon History</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={`/${creator.username}/`}
                                        title="View this user's public profile"
                                        target="_blank"
                                    >
                                        <span>Public Profile</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={`/${creator.username}/kits/`}
                                        title="View user's kits"
                                        target="_blank"
                                    >
                                        <span>Kits</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={creatorUploadLink}
                                        title="View this creator's uploads"
                                        target="_blank"
                                    >
                                        <span>Uploads</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="text-link dark"
                                        href={`/${
                                            creator.username
                                        }/collections/`}
                                        title="View this creator's collections"
                                        target="_blank"
                                    >
                                        <span>Collections</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            );
        } else {
            return null;
        }
    }

    renderCreatorUploadLink(creator) {
        let link = `/${creator.username}/uploads/`;

        if (creator.is_designer && creator.creator_info) {
            if (creator.creator_info.is_suspended) {
                link = `/search/?search_creator=${creator.id}`;
            }
        }

        return link;
    }

    renderSuspendedFlag(creator) {
        let flag;

        if (creator.is_designer && creator.creator_info) {
            if (creator.creator_info.is_suspended) {
                flag = (
                    <span
                        style={{
                            left: "5px",
                            fontSize: "18px",
                            top: "-4px",
                            position: "relative"
                        }}
                        className={
                            creator.creator_info.is_suspended
                                ? "red ui_flag"
                                : ""
                        }
                    />
                );
            }
        }

        return flag;
    }
}

function mapStateToProps(state, ownProps) {
    let creator;

    if (state.creator.keys) {
        creator = state.creator[state.creator.keys[0]];
    }

    return { creator };
}

module.exports = connect(mapStateToProps, {})(FortMemberHeader);
